import { StyleRulesCallback, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import { FirestoreSharedKeys } from "shared/firestore";
import { ICoworkBranch } from "shared/model/ICoworkSpace";

import SLSelectContainer, {
  SelectItem
} from "../../../SLSelect/SLSelectContainer";
import Colors from "../../../../assets/Colors";
import {BottomArrowWhite} from "../../../Icons/BottomArrow/BottomArrowWhite/bottomArrowWhite";

interface IProps {
  branches: ICoworkBranch[];
  onBranchSelected: (branch: ICoworkBranch) => void;
  selectedBranch: ICoworkBranch;
  currentCoworkName: string;
  enableSelection: boolean;
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    height: 32,
    cursor: "pointer",
    marginLeft: 40,
    color: Colors.colWhite
  },
  text: {
    fontSize: 14
  },
  bottomArrow: {
    width: 10,
    height: 4,
    marginTop: 4,
    marginLeft: 5
  }
});

@(withStyles(styles) as any)
export default class BranchSelector extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const { enableSelection, currentCoworkName, selectedBranch } = this.props;
    if (enableSelection) {
      return this.renderSelection();
    } else {
      const displayString = this.displayString(
        currentCoworkName,
        selectedBranch
      );
      return this.renderLabel(displayString);
    }
  }

  private renderSelection() {
    const { branches, selectedBranch } = this.props;
    return (
      <SLSelectContainer
        items={branches.map(this.branchesMap)}
        renderLabel={this.renderLabel}
        selectedItem={this.branchesMap(selectedBranch)}
        onItemSelected={this.onItemSelected}
      />
    );
  }

  private renderLabel = (displayString: string) => {
    const { classes } = this.props;
    return (
      <div className={classes!.container}>
        {displayString}
        {this.renderBottomArrowIfNeeded()}
      </div>
    );
  };

  private renderBottomArrowIfNeeded() {
    const { classes, enableSelection } = this.props;
    if (enableSelection) {
      return <BottomArrowWhite className={classes!.bottomArrow} />;
    } else {
      return null;
    }
  }

  private branchesMap = (branch: ICoworkBranch): SelectItem => {
    const { currentCoworkName } = this.props;
    const displayString = this.displayString(currentCoworkName, branch);
    return { value: branch.name, displayString };
  };

  private displayString(coworkName: string, branch: ICoworkBranch) {
    const isDefault = branch.name === FirestoreSharedKeys.DefaultBranchName;
    const displayName = isDefault ? "" : ` - ${branch.displayName}`;
    return `${coworkName}${displayName}`;
  }

  private onItemSelected = (item: SelectItem) => {
    const { value } = item;
    const { branches, onBranchSelected } = this.props;
    const selectedBranch = branches.filter(branch => branch.name === value)[0];
    onBranchSelected(selectedBranch);
  };
}



// WEBPACK FOOTER //
// ./src/components/Header/components/BranchSelector/BranchSelector.tsx